import React from "react";
import { INiche } from "@/common/services/types";
import { Image } from "components/Image";
import { nFormatter } from "@/common/utils/parseNumber";
import UsersIcon from "@/common/images/icons/users.svg?react";
import "./NicheListItem.scss";

interface INicheExtended extends Omit<INiche, "name" | "description" | "cover" | "description"> {
  name: string | JSX.Element;
}

interface INicheListItem {
  niche: INicheExtended;
  actionElement?: React.ReactNode;
}

export const NicheListItem: React.FC<INicheListItem> = ({
  niche,
  actionElement = null
}) => {
  return (
    <div className="NicheListItem" data-testid={niche.id}>
      <div className="NicheListItem-Info">
        <Image className="NicheThumb" src={niche.thumbnail} />
        <div className="NicheTexts">
          <div className="Name">{niche.name}</div>
          <div className="Subscribes">
            <UsersIcon />
            <span>{nFormatter(niche.subscribers)}</span>
          </div>
        </div>
      </div>
      { actionElement }
    </div>
  );
};
